goog.provide('el8.data.apptTypes');

goog.require('el8.data.visitNoteTypes');
goog.require('el8.data.visitNoteTemplates');
goog.require('el8.model.base');
goog.require('el8.service.urls');
goog.require('el8.util.consts');

el8.data.apptTypes = (function() {

    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);
    _class.makeDeleteable();

    _class.addStringProperty('name', true);
    _class.addStringProperty('abbreviation', true);
    _class.addStringProperty('color', true);
    _class.addIntProperty('defaultDuration', true);
    _class.addIntProperty('sequence');
    _class.addIntProperty('visitNoteTypeId', true);
    _class.addIntProperty('visitNoteTemplateId', true);
    _class.addStringProperty('visitNoteFormat', true);

    _class.prototype.getVisitNoteType = function() {
        return el8.data.visitNoteTypes.getByIdIncludingDeleted(this.getVisitNoteTypeId());
    };

    _class.prototype.getVisitNoteTemplate = function() {
        return el8.data.visitNoteTemplates.getByIdIncludingDeleted(this.getVisitNoteTemplateId());
    };

    _class.prototype.getColorDisplay = function() {
        var rgbColor = this.getColor();
        var rv = _.find(that.getAllColors(), function(color) { return rgbColor === color[1]; });
        if (rv) {
            return rv[0];
        }
        return '';
    };

    _class.prototype.asSoyMap = function() {
        var mapped = this.parent.asSoyMap.call(this);
        mapped['colorDisplay'] = this.getColorDisplay();
        // if we're in the printform, e.g., we won't care about expanding the visitNoteType
        // (If we do start to care, we need to send it down in the appt_type JSON)
        if (this.getVisitNoteTypeId() && el8.service.urls.hasUrl('visitNoteTypes') && this.getVisitNoteType()) {
            mapped['visitNoteType'] = this.getVisitNoteType().getName() ;
        }

        if (this.getVisitNoteTemplateId() && el8.service.urls.hasUrl('visitNoteTemplates') && this.getVisitNoteTemplate()) {
            mapped['visitNoteTemplate'] = this.getVisitNoteTemplate().getName();
        }

        return mapped;
    };

    var that = new el8_EntitySet({
        model: function(spec) { return new _class(spec); },
        sortFn: function(a, b) { return a.getSequence() - b.getSequence(); },
        urlLoad: function() { return el8.service.urls.get('appointmentType', [el8Globals.PRACTICE_ID]); },
        urlFn: function(id) { return el8.service.urls.get('appointmentType', [el8Globals.PRACTICE_ID, id]); },
        urlSort: function() { return el8.service.urls.get('sortAppointmentTypes'); }
    });

    that.getAllColors = function() {
        return el8.util.consts.SCHEDULER_COLORS;
    };

    that.getAllDurations = function() {
        return el8.util.consts.SCHEDULER_DURATIONS;
    };

    that.makeSetSortable({
        rankKey: 'sequence'
    });

    return that;

})();
